import ReportEditConfigController from '../ATReportEditConfigController'
import {ReportGroupingLevel} from '../../constants'
import {Feature, isEnabled} from '../../../features'
import messageResource from '../../../messageResource'
import $ from 'jquery'
import {ColumnsConfig} from '../../overtimeReport/ColumnsConfig'
import OvertimeReportColumnsFormatSelector from './OvertimeReportColumnsFormatSelector'
import OvertimeGroupingSelector from '../../OvertimeGroupingSelector'
import CustomCheckbox from '../../../components/customCheckbox/CustomCheckbox'
import {formatLFM} from '../../../util/UserNameFormat'

export default class OvertimeReportEditConfigController extends ReportEditConfigController {}

OvertimeReportEditConfigController.prototype.init = function ( config )
{
    ReportEditConfigController.prototype.init.call(this, config);

    const self = this;
    this.reportAuthorizationInfo = config.reportAuthorizationInfo
    this.reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);
    this.configChangedCallback = config.changeCallback;
    const configChanged = function () { self.configChanged(); };

    this.timeFormatSelector = this.initTimeFormatSelector(this.reportParameters.timeFormat, configChanged );

    const groupingLevelsSelection = [this.reportParameters.firstGroupingLevel, this.reportParameters.secondGroupingLevel];
    const ugrEnabled = isEnabled(Feature.UGR) || this.checkGroupingLevel(ReportGroupingLevel.USER_GROUP, groupingLevelsSelection);
    const tzgEnabled = isEnabled(Feature.TZG) || this.checkGroupingLevel(ReportGroupingLevel.TIME_ZONE_GROUP, groupingLevelsSelection);
    this.groupingSelector = new OvertimeGroupingSelector().init(
        "reportGroupingSelector",
        groupingLevelsSelection,
        ugrEnabled,
        tzgEnabled,
        function() {
            self.removeGroupingLevelsSelectionError();
            configChanged();
        }
    );
    $("#reportConfigDataGroupingRow").show();

    config.additionalCheckboxLabel = messageResource.getMessage("users_selector.reports.include_users_wo_data");

    const $usernameLabel = $('.usernameLabel')
    $usernameLabel.toggle(!this.reportAuthorizationInfo.anyOtherUsersAvailable)

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable) {
        this.userSelector = this.makeUserSelector({
            ...config,
            allUsersAvailable: this.reportAuthorizationInfo.allUsersAvailable
        });
    } else {
        $('#userSelectorId').hide()
        const user = config.users[0]
        const usernameFormatted = formatLFM(user.firstName, user.lastName, user.middleName, ", ")
        $usernameLabel.text(usernameFormatted)
    }

    if (!(isEnabled(Feature.OVR) && this.reportAuthorizationInfo.overtimeAvailable || isEnabled(Feature.LVT))) {
        $("#columnsFormatFilterRow").hide();
    }

    if (isEnabled(Feature.OVR) && this.reportAuthorizationInfo.overtimeAvailable) {
        this.makeColumnsConfigSelector(config)
    }

    if (isEnabled(Feature.LVT)) {
        this.makeShowWorkingAndLeaveTimeCheckbox(config)
        this.showWorkingAndLeaveTimeCheckbox.setState({checked: this.reportParameters.showWorkingAndLeaveTime});
    }

    return this;
};

OvertimeReportEditConfigController.prototype.getConfig = function () {
    const groupingLevelValues = this.groupingSelector ? this.groupingSelector.getValues() : [ReportGroupingLevel.USER, ReportGroupingLevel.NONE];
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        userSelection: this.reportAuthorizationInfo.anyOtherUsersAvailable ? this.userSelector.getSelection() : this.initReportParameters.userSelection,
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        columnsConfig: this.columnsConfigSelector ? this.columnsConfigSelector.getSelectedItem().value : ColumnsConfig.TIME_BALANCE_ONLY,
        showWorkingAndLeaveTime: this.showWorkingAndLeaveTimeCheckbox ? this.showWorkingAndLeaveTimeCheckbox.isChecked() : false
    };
};

OvertimeReportEditConfigController.prototype.resetConfig = function () {
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable)
        this.userSelector.setSelection(this.initReportParameters.userSelection);

    if (this.columnsConfigSelector){
        this.columnsConfigSelector.setActiveItemByValue(this.initReportParameters.columnsConfig);
    }
    if (this.showWorkingAndLeaveTimeCheckbox){
        this.showWorkingAndLeaveTimeCheckbox.setState({checked: this.initReportParameters.showWorkingAndLeaveTime});
    }
    if (this.groupingSelector)
        this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel]);
};

OvertimeReportEditConfigController.prototype.validate = function ()
{
    this.errors = [];

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable && !this.userSelector.validateIsUserSelected())
        this.errors.push( this.possibleErrors.ERROR_EMPTY_USER_SELECTION );

    if (this.groupingSelector && !this.groupingSelector.validate())
        this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length === 0;
};

OvertimeReportEditConfigController.prototype.initErrorsToSectionElsMap = function()
{
    const errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_USER_SELECTION] = this.panelEl.find( "#userSelectorId" );
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find( ".reportGroupingSelectorContainer" );
    return errorsToSectionElsMap;
};

OvertimeReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    ReportEditConfigController.prototype.setSelectorsInitStateFromCurrent.call(this);

    if(this.reportAuthorizationInfo.anyOtherUsersAvailable) {
        this.userSelector.setInitialValueFromCurrent();
    }
};

OvertimeReportEditConfigController.prototype.makeReportParamsAccordingToFeatures = function(reportParameters) {
    return reportParameters
}

OvertimeReportEditConfigController.prototype.makeColumnsConfigSelector = function()
{
    this.columnsConfigSelector = new OvertimeReportColumnsFormatSelector().init(
        this.reportParameters.columnsConfig,
        () => {
            const columnsConfig = this.columnsConfigSelector.getSelectedItem().value

            if (this.showWorkingAndLeaveTimeCheckbox) {
                this.showWorkingAndLeaveTimeCheckbox.setState({
                    checked: columnsConfig !== ColumnsConfig.OVERTIME_ONLY && this.showWorkingAndLeaveTimeCheckbox.isChecked(),
                    disabled: isEnabled(Feature.OVR) && columnsConfig === ColumnsConfig.OVERTIME_ONLY
                })
            }

            this.configChanged()
        }
    )

    $("#columnsFormatFilterTable").show();
};

OvertimeReportEditConfigController.prototype.makeShowWorkingAndLeaveTimeCheckbox = function()
{
    const $checkboxContainer = $('.showWorkingAndLeaveTimeSection')

    this.showWorkingAndLeaveTimeCheckbox = new CustomCheckbox({
        label: messageResource.getMessage('report.overtime.columns_config.show_working_and_leave_time_columns'),
        checkboxAdditionalClass: 'checkboxInput',
        checkmarkAdditionalClass: 'hiddenCheckmark',
        onChange: () => {
            this.configChanged()
        }
    }).init($checkboxContainer)

    this.showWorkingAndLeaveTimeCheckbox.setState({
        checked: this.reportParameters.columnsConfig !== ColumnsConfig.OVERTIME_ONLY && this.showWorkingAndLeaveTimeCheckbox.isChecked(),
        disabled: isEnabled(Feature.OVR) && this.reportAuthorizationInfo.overtimeAvailable && this.reportParameters.columnsConfig === ColumnsConfig.OVERTIME_ONLY
    })

    $checkboxContainer.toggleClass(
        'withoutColumnsConfig',
        !(isEnabled(Feature.OVR) && this.reportAuthorizationInfo.overtimeAvailable && isEnabled(Feature.LVT))
    )

    $checkboxContainer.show()
};


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/overtime/OvertimeReportEditConfigController.js